import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CookieConsentBanner = ({
  isVisible = false,
  onAccept = () => {},
  onDecline = () => {},
  userPreferences = false,
  isTab = false,
  code = "",
}) => {
  // Early return if conditions not met
  if (
    !userPreferences ||
    isTab ||
    code === "ios" ||
    code === "android" ||
    !isVisible
  ) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "360px",
        maxWidth: "calc(100vw - 200px)",
        backgroundColor: "rgba(255, 255, 255, 0.98)",
        backdropFilter: "blur(16px)",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        zIndex: 10000,
        padding: "16px 20px",
        animation: "slideInRight 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        willChange: "transform, opacity",
        contain: "layout style paint",
        "@keyframes slideInRight": {
          from: {
            transform: "translateX(100%) scale(0.9)",
            opacity: 0,
          },
          to: {
            transform: "translateX(0) scale(1)",
            opacity: 1,
          },
        },
        "@media (max-width: 768px)": {
          width: "320px",
          maxWidth: "calc(100vw - 120px)",
          bottom: "16px",
          right: "16px",
          padding: "14px 18px",
          borderRadius: "10px",
        },
        "@media (max-width: 480px)": {
          width: "280px",
          maxWidth: "calc(100vw - 100px)",
          bottom: "12px",
          right: "12px",
          padding: "12px 16px",
          borderRadius: "8px",
        },
      }}
    >
      {/* Header with close button */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Box
            sx={{
              width: "24px",
              height: "24px",
              backgroundColor: "#f59e0b",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: "14px",
            }}
          >
            🍪
          </Box>
          <Typography
            variant="h6"
            sx={{
              color: "#111827",
              fontSize: "16px",
              fontWeight: 600,
              margin: 0,
            }}
          >
            Cookie Settings
          </Typography>
        </Box>

        <IconButton
          onClick={onDecline}
          sx={{
            padding: "4px",
            color: "#9ca3af",
            "&:hover": {
              backgroundColor: "rgba(156, 163, 175, 0.1)",
              color: "#6b7280",
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Content */}
      <Typography
        variant="body2"
        sx={{
          color: "#6b7280",
          fontSize: "14px",
          lineHeight: "1.5",
          margin: "0 0 16px 0",
          "@media (max-width: 768px)": {
            fontSize: "13px",
            marginBottom: "14px",
          },
        }}
      >
        <b>This website uses cookies to make our site work.</b> With your
        consent, we may also use non-essential cookies to improve user
        experience and analyze website traffic. By clicking "Accept", you agree
        to our website's cookie use.
      </Typography>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", gap: "8px", flexDirection: "column" }}>
        <Button
          variant="contained"
          fullWidth
          onClick={onAccept}
          sx={{
            backgroundColor: "#3b82f6",
            color: "#ffffff",
            fontSize: "14px",
            padding: "10px 16px",
            textTransform: "none",
            borderRadius: "8px",
            fontWeight: 600,
            boxShadow: "0 2px 4px rgba(59, 130, 246, 0.2)",
            "&:hover": {
              backgroundColor: "#2563eb",
              boxShadow: "0 4px 8px rgba(59, 130, 246, 0.3)",
            },
            "@media (max-width: 768px)": {
              fontSize: "13px",
              padding: "8px 16px",
            },
          }}
        >
          Accept All Cookies
        </Button>

        <Button
          variant="outlined"
          fullWidth
          onClick={onDecline}
          sx={{
            color: "#6b7280",
            borderColor: "#d1d5db",
            fontSize: "14px",
            padding: "10px 16px",
            textTransform: "none",
            borderRadius: "8px",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "rgba(107, 114, 128, 0.04)",
              borderColor: "#9ca3af",
              color: "#374151",
            },
            "@media (max-width: 768px)": {
              fontSize: "13px",
              padding: "8px 16px",
            },
          }}
        >
          Decline All
        </Button>
      </Box>
    </Box>
  );
};
export default CookieConsentBanner;
